import { Money } from 'shared/types/product';

export const sumMoney = (...args: (Money | undefined)[]) => {
  const moneyArray = args.filter(Boolean);

  return {
    centAmount: moneyArray.reduce(
      (acc, { centAmount } = {}) => acc + (centAmount ?? 0),
      0,
    ),
    fractionDigits: moneyArray[0]?.fractionDigits,
    currencyCode: moneyArray[0]?.currencyCode,
  } as Money;
};
